export default __webpack_public_path__ + "static/media/instagram.0712b484.png";